// extracted by mini-css-extract-plugin
module.exports = {"list":"CarouselDepoiments_list__1hO0U"};